export function PinDisplay({ pin }: { pin: string }) {
  return (
    <div className="rounded-xl border-2 border-[var(--color-accent)] bg-[#FFFBEB] p-5 text-center">
      <div className="text-xs uppercase tracking-widest text-[#92400E] mb-2">
        PIN de retiro
      </div>
      <div className="font-mono text-4xl font-bold tracking-[0.4em] text-[var(--color-accent)]">
        {pin}
      </div>
    </div>
  );
}
